import { j as s, c as d } from "./utils-BdNIfrGQ.js";
import * as l from "react";
import { P as f } from "./index-oiSd2zY3.js";
var v = "Separator", n = "horizontal", N = ["horizontal", "vertical"], p = l.forwardRef((r, a) => {
  const { decorative: t, orientation: o = n, ...i } = r, e = u(o) ? o : n, m = t ? { role: "none" } : { "aria-orientation": e === "vertical" ? e : void 0, role: "separator" };
  return /* @__PURE__ */ s.jsx(
    f.div,
    {
      "data-orientation": e,
      ...m,
      ...i,
      ref: a
    }
  );
});
p.displayName = v;
function u(r) {
  return N.includes(r);
}
var c = p;
const h = l.forwardRef(({ className: r, orientation: a = "horizontal", decorative: t = !0, ...o }, i) => /* @__PURE__ */ s.jsx(
  c,
  {
    ref: i,
    decorative: t,
    orientation: a,
    className: d(
      "shrink-0 border",
      a === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]",
      r
    ),
    ...o
  }
));
h.displayName = c.displayName;
export {
  h as S
};
